import { UtensilsCrossed } from "lucide-react";
import { LUNCH_SPONSORS } from "../data/conferenceData";

export default function Sponsors() {
  return (
    <div style={{ padding: "16px", paddingBottom: "40px" }} data-testid="sponsors-page">
      <h2
        style={{
          fontSize: "22px",
          fontWeight: 800,
          color: "var(--primary-dark)",
          marginBottom: "4px",
        }}
      >
        Thank You
      </h2>
      <p
        style={{
          color: "var(--text-muted)",
          fontSize: "14px",
          marginBottom: "20px",
        }}
      >
        Lunch on June 8, 2026 is generously provided by:
      </p>

      {LUNCH_SPONSORS.map((s) => (
        <a
          key={s.name}
          href={s.url}
          data-testid={`sponsor-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
          className="block"
          style={{
            backgroundColor: "var(--surface)",
            borderRadius: "16px",
            padding: "20px",
            marginBottom: "12px",
            border: "1px solid var(--border)",
          }}
        >
          <div
            className="flex items-center"
            style={{ gap: "6px", marginBottom: "12px" }}
          >
            <UtensilsCrossed size={14} color="var(--gold)" />
            <span
              style={{
                fontSize: "11px",
                fontWeight: 800,
                letterSpacing: "1.5px",
                color: "var(--gold)",
                textTransform: "uppercase",
              }}
            >
              Lunch Sponsor
            </span>
          </div>
          <div
            className="flex items-center"
            style={{ height: "60px", marginBottom: "10px" }}
          >
            <img
              src={s.logo}
              alt={s.name}
              style={{
                maxHeight: "52px",
                maxWidth: "55%",
                objectFit: "contain",
              }}
            />
          </div>
          <p
            style={{
              fontSize: "18px",
              fontWeight: 800,
              color: "var(--primary-dark)",
            }}
          >
            {s.name}
          </p>
        </a>
      ))}
    </div>
  );
}
